<template>
  <div class="goods-vip-forever-protocol">
    <app-header :title="title" />
    <div class="protocol-content" :class="{ scroll: isBuy }">
      <span class="title">《友邻少年无限卡会员套餐协议》</span>
      <h2>【特别提示条款】</h2>
      <ul>
        <li>
          《友邻少年无限卡会员套餐协议》（以下简称“本协议”）为《用户协议》的补充协议，由您与北京每日友邻文化科技有限公司（以下称“本公司”）共同签订。
        </li>
        <li>
          【审慎阅读】您在购买友邻少年无限卡套餐流程中点击同意本协议之前，应当认真阅读本协议，并审慎选择接受或不接受本协议。
          <span class="underline">
            请您务必审慎阅读、充分理解各条款内容，并重点阅读与您约定免除或者限制责任的条款及其他以粗体下划线标识的重要条款。
          </span>
          本协议有助于您了解本公司为您提供的友邻少年无限卡会员套餐服务内容及您使用服务的权利和义务。如您对本协议条款有任何疑问，您可通过客服电话
          010-62565909 进行咨询。
        </li>
        <li>
          【签约动作】当您按照阅读并点击同意本协议且完成全部购买程序后，即表示您已充分阅读、理解并接受本协议的全部内容。
          <span class="underline">
            本协议自您点击后立即生效，并成为您与北京每日友邻文化科技有限公司之间直接有约束力的法律文件。
          </span>
        </li>
      </ul>
      <h2>第一条 服务内容</h2>
      <ul>
        <li>
          1.1
          <span class="underline">
            经您支付相关服务费用并开启无限卡套餐服务后，若无特殊情况，自您购买无限卡套餐服务之日起至2023年12月31日期间（以下简称“权限期”），已上线的友邻少年APP内所有的音频、视频类课程，学员您皆可免费畅听收听或观看。自2024年1月
            1日起，需要按照1元 /年的价格增订新一年的上新的全部课程。
          </span>
        </li>
        <li>
          1.2
          <span class="underline">
            当您支付相关服务费用并开启无限卡套餐服务后，本公司向您赠送3张畅听月卡，请您注意赠送月卡需在发放之日起一个自然年度内激活使用，否则赠送月卡将失效，为了方便您使用月卡，您可以将月卡赠送亲友，可支持全部赠送月卡赠与同一亲友。
          </span>
        </li>
        <li>
          1.3
          <span class="underline">
            当您购买本会员套餐服务，即代表您理解并同意，由于包括但不限于版权到期或课程调整等其他原因，本公司可能会不定期对友邻少年APP内课程数量及内容进行新增或下架调整。
            新增的课程，您在权益有效期内可以进行收听或观看；下架的课程，您将无法继续收听或观看。相关课程学习使用方式的最终解释权归本公司所有。
          </span>
        </li>
        <li>
          1.4
          <span class="underline">
            本公司提供的除课程内容外的免费服务，可能根据实际情况会对服务内容、服务方式等进行调整。
          </span>
        </li>
      </ul>
      <h2>第二条 收费标准</h2>
      <ul>
        <li>2.1 无限卡会员套餐服务是收费服务，当您根据提示支付完毕相关费用后，本项服务即时生效。</li>
        <li>
          2.2
          本公司可能会根据本服务的整体规划，对本服务相关权益细则、收费标准、方式等进行修改和变更，并可能根据实际情况，对不同阶段的会员给予不同的增值服务或资费政策，
          <span class="underline">
            具体收费标准以本公司在友邻少年APP相关页面公示的信息为准。您同意继续操作的行为（包括但不限于点击同意、支付、收听、观看等行为）及/或在合理的时间并未明确提出异议的不作为，即视为您知悉并同意该收费标准。
          </span>
        </li>
        <li>
          2.3 分期付款
          <br />
          无限卡会员套餐费用可以自主选择一次性全款支付或分期支付。采用分期付款，分期为免息，分期期数为6期或10期，支持自选期数。
        </li>
        <li>
          2.4 您需要在每月还款日之前，完成当月应还分期款项金额的支付，直至所有分期款项金额全部支付为止。
          <br />
          若逾期未还款，所有会员权益将自动暂停，无法继续学习并享受服务；当您支付完毕所有逾期金额后，会员权益将自动恢复。
        </li>
        <li>
          2.5
          <div class="underline">
            若在自选付款期数内，未完成需要支付的全部分期金额，会保留账号当前权益3个月，3个月后若仍未完成全部分期金额的支付，默认您同意该不作为标志着您已经自愿放弃此账号的使用权，您无限卡会员的权益和订单将被直接取消，之后无法继续还款和学习。
          </div>
        </li>
      </ul>
      <h2>第三条 退款服务</h2>
      <ul>
        <li>
          3.1
          无限卡会员套餐为“7天内可退款”商品，您应按照《用户协议》关于“退款服务”的约定进行退款申请，但“7天内”退款须同时满足如下条件，如果超过7天的，则不可申请退款：
          <div class="underline">
            <br />
            (a) 申请退款时间在付款之日起的7个自然日内；
            <br />
            (b) 申请退款的用户听课时长不足180分钟；
            <br />
            (c) 申请退款的用户不得下载超过3个音视频及/或视频文件（包含3个）。
          </div>
        </li>

        <li>
          3.2
          本条款约定的退款金额的计算基数系您在购买订阅无限卡会员套餐服务时所实际支付的金额，不包含优惠券、奖励金等（以下简称“实际支付金额”）。退款金额将扣除报名时赠送的实体礼包金额（全款实体礼包1700元，分期实体礼包1200元）后，返回退款至您支付时所选择的支付渠道。
        </li>
      </ul>

      <h2>第四条 服务中断或终止</h2>
      <ul>
        <li class="underline">
          如您发生下列任何一种情况，本公司有权
          <span class="underline">随时中断或终止</span>
          向您提供本条款项下的课程服务而无需通知您：
          <br />
          <div class="underline">
            （1）提供的个人资料不真实；
            <br />
            （2）通过未经本公司授权的渠道购买无限卡会员套餐；
            <br />
            （3）盗录本公司课程；
            <br />
            （4）未经本公司授权，利用本公司资源为自己创造便利或牟取利益，如进行课程或资料售卖等；进行用户引流、用于个人宣传等；
            <br />
            （5）售卖本公司的优惠券、礼品卡等行为；
            <br />
            （6）以任何形式在任何媒体散布对本公司不利的言论或信息；
            <br />
            （7）以包括但不限于以评论、求关注等方式对他人反复发送重复、近似，诉求相同的信息等方式骚扰他人，反复指2次及以上；
            <br />
            （8）违反本协议约定及友邻少年《用户协议》或友邻少年APP上的任何其他条款；
            <br />
            （9）违反国家法律、法规的其他规定。
          </div>
          <span class="underline">
            在发生上述情况下，本公司有权暂时或永久封禁您的账号。在封禁期间，无限卡会员套餐服务时长不停止计算，同时您无法申请退款。
          </span>
        </li>
      </ul>

      <h2>第五条 其他</h2>
      <ul>
        <li>
          本协议为友邻少年《用户协议》的补充协议，本协议未约定事宜，均适用《用户协议》相关约定。如果您对于本协议的履行及解释产生任何争议的，均应提交本公司所在地有管辖权的人民法院，通过诉讼的方式解决。
        </li>
      </ul>
    </div>
    <!-- 选择协议购买 -->
    <div class="select-protocol-buy" v-if="isBuy">
      <div class="select-protocol">
        <span class="card-icon">
          <img
            class="icon-32"
            v-if="form.protocol === 1"
            @click="toggleValue('protocol')"
            src="../../../../images/goods-vip-forever/icon-checkbox-select.png"
            alt=""
          />
          <img
            class="icon-32"
            v-if="form.protocol === 0"
            @click="toggleValue('protocol')"
            src="../../../../images/goods-vip-forever/icon-checkbox.png"
            alt=""
          />
          <span class="link" @click="detailView('goods-vip-forever-protocol2022')">同意《无限卡购买协议》</span>
        </span>
        <button class="btn btn-active" @click="buyGoods">立即购买</button>
      </div>
    </div>
  </div>
</template>

<script>
import Body from '@/mixins/body'
import { Toast } from 'mint-ui'
const componentName = 'goods-vip-forever-protocol2023'
export default {
  name: componentName,
  componentName,
  mixins: [Body],
  data() {
    return {
      title: '友邻少年无限卡会员套餐协议',
      form: {
        protocol: 0
      }
    }
  },
  computed: {
    isBuy() {
      return this.$route.query.isBuy
    }
  },
  methods: {
    toggleValue(name) {
      const value = this.form[name]
      this.form[name] = value ? 0 : 1
    },
    buyGoods() {
      if (this.form.protocol === 0) {
        Toast({ message: '请阅读并勾选《无限卡购买协议》，否则无法进行购买', position: 'middle' })
      } else {
        const { goodsId } = this.$route.query
        // 跳转订单支付
        if (goodsId) {
          this.$router.push({
            path: `/confirm-order/${goodsId}`,
            query: { paytype: 'vip' }
          })
        } else {
          Toast({ message: '请联系班主任获取《无限卡购买》入口', position: 'middle' })
        }
      }
    }
  }
}
</script>

<style lang="scss">
.body-goods-vip-forever-protocol {
  #app {
    display: flex;
    .goods-vip-forever-protocol {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
<style lang="scss" scoped>
.protocol-content {
  // height: 70%;
  overflow: scroll;
}
// 选择协议
.select-protocol-buy {
  margin: 0.3rem 0.3rem;
  border-top: 1px solid #eeeeee;
  padding-top: 0.3rem;
  .select-protocol {
    .card-icon {
      margin-right: 0.15rem;
    }
    .link {
      text-decoration: underline;
      margin-left: 0.15rem;
    }
    // 图标
    .icon-32 {
      vertical-align: sub;
      width: 0.32rem;
    }
    // 购买按钮
    .btn {
      padding: 0.24rem 0.4rem;
      background-color: #00b25a;
      border-radius: 0.12rem;
      color: #fff;
      width: 100%;
      margin-top: 0.3rem;
    }
  }
}
ul {
  margin: 0.2rem 0.2rem;
}
ul li {
  list-style: none;
  line-height: 0.5rem;
  font-size: 0.3rem;
  margin: 0.3rem 0.2rem;
  &.weight,
  .weight {
    font-weight: bold;
  }
  .underline {
    text-decoration: underline;
    font-weight: 600;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #44546a;
  }
  table {
    width: 100%;
    min-height: 25px;
    line-height: 25px;
    text-align: center;
    border-collapse: collapse;
    padding: 2px;
  }
}
.indent {
  margin-left: 20px;
}
ul.indent {
  margin-left: 25px;
  margin-top: 0;
}
.title {
  text-align: center;
  margin-top: 20px;
  display: block;
}
h2 {
  margin: 0.48rem 0.48rem 0.3rem 0.4rem;
  font-size: 0.32rem;
}
.company {
  display: flex;
  flex-direction: column;
  text-align: right;
  margin-top: 10px;
}
.link {
  text-decoration: none;
  color: #44546a;
}
</style>
